export const environment = {
    production: false,
    name: 'development',
    apiURL: "https://agnapideviot.azurewebsites.net/api/",
    azureAd: {
        clientId: "e1346f20-eb43-4532-8fd7-ee2931e3f0b4",
        tenantId: "6f4d03de-9551-4ba1-a25b-dce6f5ab7ace",
        authority: "https://login.microsoftonline.com/abbvie.onmicrosoft.com/",
        redirectUri: "https://bcproductsupportdev.allerganaesthetics.com",
        scopeUri: "api://a426d3f8-669a-4595-a9c4-1d39d0f515f1/.default",
        postLogoutRedirectUri: "https://bcproductsupportdev.allerganaesthetics.com",
        navigateToLoginRequestUrl: false
    }
};